/* eslint-disable semi,semi-style */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { SWRConfig } from 'swr';
import feMonitor from '@didi/fe-monitor';
import App from './app';
import request from '@/util/request';
import useSign from '@/util/sign';
useSign();
// 初始化
feMonitor.setConfig({
  appid: '10027',
  moduleName: 'epower-open',
  auto: true,
});

const container = document.getElementById('epower-open-root');
if (container) {
  createRoot(container).render(
    <SWRConfig
      value={{
        fetcher: request,
      }}>
      <App />
    </SWRConfig>,
  );
}
